export const getters = {
  IS_AUTH: (state) => state.is_auth,
  USER: state => state.user,
  ROLE_NAME: state => state.role_name,
  REG_DATE_PASSED: state => state.reg_date_passed,
  APPLICATION_EDIT_DATE_PASSED: state => state.applicationEditDatePassed,
  REG_DATE_HACKATHON_PASSED: state => state.regDateHackathonPassed,
  PASSED_DATES: state => state.passedDates,
}
